module.exports = __webpack_public_path__ + "media/Video 34.240b5da8.mp4";